import React, { useEffect, useState, useCallback, useRef } from "react";
import Header from "../components/header/index";
import { useNavigate, useLocation } from "react-router-dom";
import "../styles/requestdetails.css";
import { get, post, put } from "../config/api";
import { Loader } from "../components/loader";
import { Close, Download, Search } from "../constants";
import DeliveryCodeModal from "../components/deliverycodeModal";
import Modal from "../components/modal";
import { API_ENDPOINTS } from "../config/apiEndpoints";
import { userType } from "../constants/textconstants";
import { formatDateTime, formatDateToDDMMYYYY } from "../helper-functions";
import ApproveModal from "../components/modal/approveModal";

interface ViewDetailsProps {
  request: RequestType;
  isIN57?: boolean;
  onPreview?: (url: string) => void;
}
interface RequestType {
  request_id: string;
  created_at: string;
  partner_id: string;
  govt_application_number: string;
  gst_number?: string;
  license_number: string;
  license_issued_date: string;
  license_expiry_date: string;
  firm_name: string;
  shop_address: string;
  shop_district: string;
  shop_pincode: string;
  godown_same_as_shop: boolean;
  godown_address: string;
  godown_district: string;
  godown_pincode: string;
  assigned_to: string;
  due_date: string;
  due_date_message: string;
  status: string;
  message: string;
  remarks?: string;
  reason?: string;
  delivery_code?: string;
  delivery_date: string;
  unit?: string;
  products: string[];
  license_documents: { document_key: string; document_url: string }[];
  certificate_trackings: {
    step: string;
    status: string;
    last_updated_at: string;
  }[];
  certificate?: {
    certificate_number: string;
    partner: {
      partner_id: string;
      name: string;
      territory: string;
    };
    issued_date: string;
    expiry_date: string;
    certificate_copy_first_page_url: string;
    certificate_copy_last_page_url: string;
  };
  partner_location: string;
  distributor_ids?: string[];
  distributors?: string;
}

interface DistributorOption {
  id: string | number;
  label: string;
}

interface PrincipalCertificateProps {
  request: RequestType;
  userData: any;
  onPreview?: (url: string) => void;
}



const PrincipalCertificate: React.FC<PrincipalCertificateProps> = React.memo(({
  request,
  userData,
  onPreview,
}) => {
  const currentStatus = request.status;
  const description = request.status.toLowerCase() === "rejected" ? request.reason : request.message;
  let badgeClass = "";

  switch (currentStatus) {
    case "Rejected":
      badgeClass = "rejected";
      break;
    case "Cancelled":
      badgeClass = "cancelled";
      break;
    case "Expired":
      badgeClass = "expired";
      break;
    case "Approved":
      badgeClass = "pending";
      break;
    case "Pending Delivery":
      badgeClass = "pending";
      break;
    case "Active":
      badgeClass = "active";
      break;
    default:
      badgeClass = "in-progress";
      break;
  }

  return (
    <>
      {request && request.products && (
        <div className="principal-cert-container">
          <h2 className="principal-cert-title">
            Principal Certificate - Crop Protection
          </h2>
          <div className="principal-cert-id-status">
            <span>Request ID: {request.request_id}</span>
            <span className={`principal-cert-status-badge ${badgeClass}`}>
              {currentStatus}
            </span>
          </div>
          <p className="principal-cert-description" style={{ color: currentStatus.toLowerCase() == 'cancelled' ? '#E65100' : currentStatus.toLowerCase() == 'expired' ? '#C62828' : 'rgba(0, 0, 0, 0.60)' }}>{currentStatus.toLowerCase() == 'rejected' && 'Reason : '}{description}</p>

          {(currentStatus.toLowerCase() === "pending delivery" ||
            currentStatus.toLowerCase() === "cancelled" ||
            currentStatus.toLowerCase() === "expired" ||
            currentStatus.toLowerCase() === "active") && (
              <div className="certificate-details" style={{
                borderTop: (userData &&
                  userData.partner_type &&
                  userData.partner_type.toLowerCase() === userType.RETAILER &&
                  currentStatus.toLowerCase() === "pending delivery" &&
                  request.delivery_code && request.unit !== 'IN57') ? 'none' : '7px solid #e5e7eb'
              }}>
                {userData &&
                  userData.partner_type &&
                  userData.partner_type.toLowerCase() === userType.RETAILER &&
                  currentStatus.toLowerCase() === "pending delivery" &&
                  request.delivery_code && request.unit !== 'IN57' && (
                    <div className="delivery-section">
                      <div className="delivery-label">Delivery code</div>
                      <div className="delivery-code">
                        {request.delivery_code.split("").map((digit, idx) => (
                          <div className="code-box" key={idx}>
                            {digit}
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                <div style={{ padding: 16 }}>
                  <h2 className="request-updates-title">Certificate Details</h2>
                  <div className="certificate-inline-row">
                    <div className="certificate-detail-row">
                      <span className="detail-label">Certificate No.</span>
                      <span className="detail-value">
                        {request.certificate?.certificate_number || "-"}
                      </span>
                    </div>
                    <div className="certificate-detail-row">
                      <span className="detail-label">Certificate Copy</span>
                      <div style={{ display: "flex", flexWrap: 'wrap' }}>
                        {request.certificate?.certificate_copy_first_page_url ? (
                          <a


                            onClick={(e) => {
                              e.preventDefault();
                              onPreview && onPreview(request.certificate!.certificate_copy_first_page_url);
                            }}


                            rel="noopener noreferrer"
                            className="download-link"
                          >
                            First Page <img src={Download} height={20} />
                          </a>
                        ) : (
                          "-"
                        )}
                        {request.certificate?.certificate_copy_last_page_url ? (
                          <a
                            onClick={(e) => {
                              e.preventDefault();
                              onPreview && onPreview(request.certificate!.certificate_copy_last_page_url);
                            }}

                            rel="noopener noreferrer"

                            className="download-link"
                          >
                            Last Page <img src={Download} height={20} />
                          </a>
                        ) : (
                          "-"
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="certificate-inline-row">
                    <div className="certificate-detail-row">
                      <span className="detail-label">Issue Date</span>
                      <span className="detail-value">
                        {request.certificate ? formatDateToDDMMYYYY(request.certificate.issued_date) : "-"}
                      </span>
                    </div>
                    <div className="certificate-detail-row">
                      <span className="detail-label">Expiry Date</span>
                      <span className="detail-value">
                        {request.certificate?.expiry_date ? formatDateToDDMMYYYY(request.certificate.expiry_date) : "No Expiry Date"}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            )}
        </div>
      )}
    </>
  );
});

interface RequestUpdatesProps {
  request: RequestType;
}

const RequestUpdates: React.FC<RequestUpdatesProps> = React.memo(({ request }) => {
  const renderUpdateItem = (item: any, index: number) => {
    let iconWrapperClass = "";
    let showSvg = false;
    let showInnerCircle = false;
    const status = item.status.toLowerCase();

    switch (status) {
      case "done":
      case "completed":
        iconWrapperClass = "done";
        showSvg = true;
        break;
      case "pending":
        iconWrapperClass = "pending";
        showInnerCircle = true;
        break;
      case "in progress":
        iconWrapperClass = "in-progress";
        showInnerCircle = true;
        break;
      case "rejected":
      case "expired":
        iconWrapperClass = "rejected";
        showInnerCircle = true;
        break;
      case "cancelled":
        iconWrapperClass = "cancelled";
        showInnerCircle = true;
        break;
      default:
        iconWrapperClass = "pending";
        showInnerCircle = true;
    }

    return (
      <>
        {request && (
          <div className="update-item" style={{ marginBottom: item.last_updated_at ? 0 : 20 }} key={index}>
            <div className={`update-icon-wrapper ${iconWrapperClass}`}>
              {showSvg && (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-4 w-4"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M5 13l4 4L19 7"
                  />
                </svg>
              )}
              {showInnerCircle && <div className="inner-circle"></div>}
            </div>
            <div className="update-content">
              <div className="update-header">
                <span className="update-name">{item.step}</span>
                <span className={`update-status ${iconWrapperClass}`}>
                  {item.status}
                </span>
              </div>
              {item.last_updated_at && (
                <p className="update-date">
                  {formatDateTime(new Date(item.last_updated_at))}
                </p>
              )}
            </div>
          </div>
        )}
      </>
    );
  };

  return (
    <div className="request-updates-container">
      <h2 className="request-updates-title">Request Updates</h2>
      <div className="request-updates-list">
        <div className="progressBar"></div>
        {request?.certificate_trackings?.map((step, i) =>
          renderUpdateItem(step, i)
        )}
      </div>
    </div>
  );
});

// ViewDetails Component
const ViewDetails: React.FC<ViewDetailsProps> = React.memo(({ request, isIN57, onPreview }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleOpen = () => {
    setIsOpen(!isOpen);
  };


  return (
    <div className="view-details-container">
      <div className="view-details-header" onClick={toggleOpen}>
        <h2 className="request-updates-title">View Details</h2>
        <button className="view-details-toggle-button">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className={`h-6 w-6 ${isOpen ? "rotate" : ""}`}
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M5 15l7-7 7 7"
            />
          </svg>
        </button>
      </div>
      {isOpen && (
        <div className="view-details-content">
          <>
            {request.govt_application_number && (
              <>
                <div className="detail-item">
                  <span className="detail-label">Application ID</span>
                  <span className="detail-value">
                    {request.govt_application_number}
                  </span>
                </div>
                <p className="detail-note">
                  (Request ID as per Mahaparwana govt. site)
                </p>
              </>
            )}
          </>

          <div className="detail-item">
            <span className="detail-label">Firm Name</span>
            <span className="detail-value">{request.firm_name}</span>
          </div>
          <p className="detail-note">(as per License)</p>

          <div className="detail-item">
            <span className="detail-label">GST Number</span>
            <span className="detail-value">{request.gst_number || "-"}</span>
          </div>

          <div className="detail-item">
            <span className="detail-label special-width">Pesticides License Number</span>
            <span className="detail-value">{request.license_number}</span>
          </div>

          <div className="detail-item">
            <span className="detail-label special-width">Pesticides License Issue Date</span>
            <span className="detail-value">{formatDateToDDMMYYYY(request.license_issued_date)}</span>
          </div>

          <div className="detail-item" style={{ paddingBottom: 16 }}>
            <span className="detail-label special-width">Pesticides License Expiry Date</span>
            <span className="detail-value">{formatDateToDDMMYYYY(request.license_expiry_date)}</span>
          </div>
          <div className="section-separator"></div>

          <div className="license-copy-section">
            <span className="license-copy-label">Pesticides License copy</span>
            <div className="license-copy-link-wrapper">
              {request.license_documents &&
                request.license_documents.map((item, i) => {
                  return (
                    <span
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        marginRight: 20,
                      }}
                    >
                      <span className="license-copy-link">License Copy -{i + 1}</span>
                      <a
                        key={i}
                        onClick={(e) => {
                          e.preventDefault();
                          onPreview && onPreview(item.document_url);
                        }}

                        rel="noopener noreferrer"
                        className="license-copy-download-button"
                      >
                        <img src={Download} height={20} />
                      </a>
                    </span>
                  );
                })}
            </div>
          </div>
          <div className="section-separator"></div>
          {!isIN57 && (
            <>
              <div className="detail-item-full">
                <span className="detail-label">Your Distributor</span>
                <span className="detail-value">
                  {request.distributors}
                </span>
              </div>
              <div className="section-separator"></div>
            </>
          )}
          <div className="detail-item-full">
            <span className="detail-label">Products for Certificate </span>
            <span className="detail-value">
              {request.products && request.products.join(", ")}
            </span>
          </div>
          <div className="section-separator"></div>
          <div className="detail-item-full">
            <span className="detail-label">Shop Address </span>
            <span className="desc_detail">(Used as your business communication address)</span>
            <span className="address-text">{request.shop_address + ", " + request.shop_district + ", " + request.shop_pincode}</span>
          </div>
          <div className="section-separator"></div>
          <div className="detail-item-full">
            <span className="detail-label">Godown Address </span>
            <span className="address-text">{request.godown_address + ", " + request.godown_district + ", " + request.godown_pincode}</span>
          </div>
        </div>
      )}
    </div>
  );
});

// Main Export
export const RequestDetails: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { request } = (location.state as { request: RequestType }) || {};

  const handleHelpClick = () => navigate("/help");
  const handleBackClick = () => window.history.back();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [freshRequestData, setFreshRequestData] = useState<any>();
  const [userData, setUserData] = useState<any>({});
  const [showDeliveryCodeModal, setShowDeliveryCodeModal] = useState(false);

  // Approve / Reject state
  const [showDistributorModal, setShowDistributorModal] = useState(false);
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [rejectRemarks, setRejectRemarks] = useState('');
  const [rejectReason, setRejectReason] = useState('');
  const [distributorList, setDistributorList] = useState<DistributorOption[]>([]);
  const [selectedDistributors, setSelectedDistributors] = useState<DistributorOption[]>([]);
  const [distributorSearch, setDistributorSearch] = useState('');
  const[showApproveModal, setShowApproveModal] = useState(false);

  // Image Preview state
  const [previewImageUrl, setPreviewImageUrl] = useState<string | null>(null);
  const [previewZoom, setPreviewZoom] = useState(1);
  const [previewPosition, setPreviewPosition] = useState({ x: 0, y: 0 });
  const isDragging = useRef(false);
  const dragStart = useRef({ x: 0, y: 0 });

  const handlePreview = (url: string) => {
    setPreviewImageUrl(url);
    setPreviewZoom(1);
    setPreviewPosition({ x: 0, y: 0 });
  };

  const closePreview = () => {
    setPreviewImageUrl(null);
    setPreviewZoom(1);
    setPreviewPosition({ x: 0, y: 0 });
  };

  const handlePreviewPointerDown = (e: React.PointerEvent) => {
    if (previewZoom > 1) {
      isDragging.current = true;
      dragStart.current = { x: e.clientX - previewPosition.x, y: e.clientY - previewPosition.y };
      (e.target as HTMLElement).setPointerCapture(e.pointerId);
    }
  };

  const handlePreviewPointerMove = (e: React.PointerEvent) => {
    if (isDragging.current) {
      setPreviewPosition({
        x: e.clientX - dragStart.current.x,
        y: e.clientY - dragStart.current.y,
      });
    }
  };

  const handlePreviewPointerUp = () => {
    isDragging.current = false;
  };

  const loadInitialData = useCallback(async () => {
    let storedUserData: any = localStorage.getItem("userData");
    const parsedUserData = storedUserData ? JSON.parse(storedUserData) : null;
    if (parsedUserData) setUserData(parsedUserData);

    try {
      const response = await get(
        API_ENDPOINTS.GET_CERTIFICATE_REQUEST_DETAILS(request.request_id)
      );
      if (response) {
        setFreshRequestData(response);
      }
    } catch (error) {
      console.error("Error fetching request details:", error);
    } finally {
      setIsLoading(false);
    }
  }, [request.request_id]);

  const fetchDistributors = async () => {
    try {
      const userId = freshRequestData.partner_id;
      if (!userId) return;
      const response = await get(API_ENDPOINTS.GET_DISTRIBUTORS(userId));
      if (response && Array.isArray(response)) {
        const distributors: DistributorOption[] = response.map((item: any) => ({
          id: item.partner_id,
          label: item.name,
        }));
        setDistributorList(distributors);
      }
    } catch (error) {
      console.error('Error fetching distributors:', error);
    }
  };

  const handleApproveClick = () => {
    if (freshRequestData?.partner_type?.toLowerCase() === userType.RETAILER) {
      fetchDistributors();
      // Pre-populate with customer-chosen distributors
      if (freshRequestData?.distributor_ids && distributorList.length > 0) {
        const preSelected = distributorList.filter((d) =>
          freshRequestData.distributor_ids.includes(String(d.id))
        );
        setSelectedDistributors(preSelected);
      }
    }
    setShowDistributorModal(true);
  };

  const handleApproveAndForward = async () => {
    const distributorIds = selectedDistributors.map((d) => d.id);
    setIsLoading(true);
    try {
      const response = await put(
        `${API_ENDPOINTS.APPROVE_CERTIFICATE_REQUEST(freshRequestData.request_id)}`,
        { distributor_ids: distributorIds }
      );
      if (response) {
        setShowDistributorModal(false);
        navigate(-1);
      }
    } catch (error) {
      console.error('Error approving request:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleRejectClick = () => {
    setRejectRemarks('');
    setRejectReason('');
    setShowRejectModal(true);
  };

  const handleRejectSubmit = async () => {
    setIsLoading(true);
    try {
      const response = await put(
        `${API_ENDPOINTS.CERTIFICATE_REQUESTS_REJECT(freshRequestData.request_id)}`,
        { remarks: rejectRemarks, reason: rejectReason }
      );
      if (response) {
        alert("Certificate request rejected!");
        setShowRejectModal(false);
        navigate(-1);
      } else {
        alert("Failed to reject certificate request. Please try again.");
      }
    } catch (error) {
      alert("An error occurred. Failed to reject certificate request.");
      console.error("API call failed:", error);
    } finally {
      setIsLoading(false);
    }
    setShowRejectModal(false);
  };

  const handleDeliveryCodeClick = () => setShowApproveModal(true);

  const handleDeliveryCodeSubmit = useCallback(async (deliveryCode: string) => {
    if (!freshRequestData) return;

    if (deliveryCode === freshRequestData.delivery_code) {


      try {
        const response = await post(
          `${API_ENDPOINTS.CERTIFICATE_REQUESTS_DELIVER(
            freshRequestData.request_id
          )}?delivery_code=${deliveryCode}`,
          {}
        );
        if (response) {
          navigate(-1);
        }
        console.log("Status updated to Active successfully.");
      } catch (error) {
        console.error("Failed to update status:", error);
      }
    } else {
      alert("Delivery code mismatch!!!!");
    }

    setShowDeliveryCodeModal(false);
  }, [freshRequestData, navigate]);

  // Pre-populate selected distributors once both list and request data are available
  useEffect(() => {
    if (freshRequestData?.distributor_ids && distributorList.length > 0) {
      const preSelected = distributorList.filter((d) =>
        freshRequestData.distributor_ids.includes(String(d.id))
      );
      setSelectedDistributors(preSelected);
    }
  }, [freshRequestData, distributorList]);

  useEffect(() => {
    setIsLoading(true);
    loadInitialData();
  }, [request.request_id]);

  if (!freshRequestData)
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          position: "absolute",
          left: 0,
          right: 0,
          bottom: 0,
        }}
      >
        <Loader />
      </div>
    );
  //console.log(freshRequestData, 'freshRequestData', userData)
  const isIN57 = userData?.mappedLocations?.some((loc: any) => loc.unit_code === "IN57") || false;
  return (
    <div className="main-content-wrapper">
      {isLoading && <Loader />}
      <Header
        title="Principal Certificate"
        actionText="Need Help?"
        onActionClick={handleHelpClick}
        onBackClick={handleBackClick}
      />
      {freshRequestData && (
        <PrincipalCertificate request={freshRequestData} userData={userData} onPreview={handlePreview} />
      )}
      {freshRequestData && (userData.role.toLowerCase() !== userType.ISSUER) && <RequestUpdates request={freshRequestData} />}
      {freshRequestData && <ViewDetails request={freshRequestData} isIN57={isIN57} onPreview={handlePreview} />}

      {userData &&
        userData.role &&
        userData.role.toLowerCase() === userType.ISSUER &&
        freshRequestData.status.toLowerCase() === "pending approval" && (
          <div className="approval-footer">
            <p className="approval-footer-date">
              Approve or Reject by {formatDateToDDMMYYYY(freshRequestData.due_date) || '-'}
            </p>
            <div className="approval-footer-buttons">
              <button className="reject-button" onClick={handleRejectClick} style={{
                backgroundColor: '#D32F2F',
                color: '#fff',
                borderRadius: 8,
                fontWeight: 600,
                lineHeight: '26px',
                fontSize: 15,
                letterSpacing: '0.46px'
              }}>Reject</button>
              <button className="approve-button" onClick={handleApproveClick} style={{
                backgroundColor: '#01830C',
                borderRadius: 8,
                fontWeight: 600,
                lineHeight: '26px',
                fontSize: 15,
                letterSpacing: '0.46px'
              }}>Approve</button>
            </div>
          </div>
        )}

      {/* Distributor Selection Modal (Approve) */}
      <Modal isOpen={showDistributorModal} onClose={() => { setShowDistributorModal(false); setDistributorSearch(''); }}>
        <div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <h3>Approve Request</h3>
            <img src={Close} style={{ height: 25, width: 25, cursor: 'pointer' }} alt="close" onClick={() => { setShowDistributorModal(false); setDistributorSearch(''); }} />
          </div>
          {freshRequestData?.partner_type?.toLowerCase() === userType.RETAILER ? (
            <>
              <span style={{ display: 'block', marginBottom: 20, fontSize: 14 }}>Confirm the distributor mapping for this retailer and proceed.</span>
              <input
                type="text"
                className="search-input"
                placeholder="Search for distributors"
                value={distributorSearch}
                style={{
                  backgroundImage: `url(${Search})`,
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: '3px 10px',
                  backgroundSize: 21
                }}
                onChange={(e) => setDistributorSearch(e.target.value)}
              />
              <div className="options-list">
                {distributorList
                  .filter((d) => d.label.toLowerCase().includes(distributorSearch.toLowerCase()))
                  .map((option) => (
                    <div
                      key={option.id}
                      className="option-item"
                      onClick={() => {
                        const exists = selectedDistributors.find((o) => o.id === option.id);
                        if (exists) {
                          setSelectedDistributors(selectedDistributors.filter((o) => o.id !== option.id));
                        } else {
                          setSelectedDistributors([...selectedDistributors, option]);
                        }
                      }}
                    >
                      <span>{option.label}</span>
                      <input
                        type="checkbox"
                        checked={selectedDistributors.some((o) => o.id === option.id)}
                        onChange={() => { }}
                      />
                    </div>
                  ))}
                {distributorList.filter((d) => d.label.toLowerCase().includes(distributorSearch.toLowerCase())).length === 0 && (
                  <div style={{ height: 200, width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: 14 }}>
                    No matching distributors found
                  </div>
                )}
              </div>
              <button
                className="confirm-btn"
                disabled={selectedDistributors.length === 0}
                style={{
                  opacity: selectedDistributors.length === 0 ? 0.5 : 1,
                  backgroundColor: '#01830C',
                  borderRadius: 8,
                  fontWeight: 600,
                  lineHeight: '26px',
                  fontSize: 15,
                  letterSpacing: '0.46px'
                }}
                onClick={handleApproveAndForward}
              >
                Approve & Forward
              </button>
            </>
          ) : (
            <button
              className="confirm-btn"
              style={{
                backgroundColor: '#01830C',
                borderRadius: 8,
                fontWeight: 600,
                lineHeight: '26px',
                fontSize: 15,
                letterSpacing: '0.46px'
              }}
              onClick={handleApproveAndForward}
            >
              Approve & Forward
            </button>
          )}
        </div>
      </Modal>

      {/* Reject Remarks Modal */}
      <Modal isOpen={showRejectModal} onClose={() => setShowRejectModal(false)}>
        <div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <h3 style={{marginTop:0}}>Reject Request</h3>
            <img src={Close} style={{ height: 25, width: 25, cursor: 'pointer' }} alt="close" onClick={() => setShowRejectModal(false)} />
          </div>
          <label style={{ fontSize: 14, display: 'block', marginBottom: 8, fontWeight: 600 }}>Reason</label>
          <select
            className="reject-remarks-textarea"
            value={rejectReason}
            onChange={(e) => setRejectReason(e.target.value)}
            style={{ marginBottom: 16, padding: 12, borderRadius: 8, border: '1px solid #ddd', fontSize: 14, width: '100%', boxSizing: 'border-box', backgroundColor: '#fff' }}
          >
            <option value="">Choose a reason the partner will see</option>
            <option value="License copy uploaded is not clear">License copy uploaded is not clear</option>
            <option value="Valid license number is not entered">Valid license number is not entered</option>
            <option value="Updated license issue date is incorrect">Updated license issue date is incorrect</option>
            <option value="Updated license expiry date is incorrect">Updated license expiry date is incorrect</option>
            <option value="License has expired">License has expired</option>
            <option value="Shop address is incorrect">Shop address is incorrect</option>
            <option value="Godown address is incorrect">Godown address is incorrect</option>
            <option value="District/Jurisdiction updated is incorrect">District/Jurisdiction updated is incorrect</option>
            <option value="Request ID from Mahaparwana portal is incorrect (only for Maharashtra users)">Request ID from Mahaparwana portal is incorrect (only for Maharashtra users)</option>
            <option value="Please contact your Bayer representative for more information">(Other) Please contact your Bayer representative for more information</option>
          </select>
          <label style={{ fontSize: 14, display: 'block', marginBottom: 8, fontWeight: 600 }}>Internal remarks</label>
          <textarea
            className="reject-remarks-textarea"
            placeholder="Enter internal remarks"
            value={rejectRemarks}
            onChange={(e) => setRejectRemarks(e.target.value)}
            rows={4}
          />
          <button
            className="reject-submit-button"
            disabled={!rejectReason}
            style={{ opacity: !rejectReason ? 0.5 : 1 }}
            onClick={handleRejectSubmit}
          >
            Reject
          </button>
        </div>
      </Modal>

      {userData &&
        userData.role &&
        userData.role.toLowerCase() === userType.ISSUER &&
        (freshRequestData.status.toLowerCase() === "pending delivery" || freshRequestData.status.toLowerCase() === "certificate issuance") && (
          <div className="action-buttons-container" style={{flexDirection: 'column', alignItems: 'center', justifyContent:'center'}}>
             <p className="approval-footer-date">
              Deliver Certificate By {formatDateToDDMMYYYY(freshRequestData.due_date) || '-'}
            </p>
            <button
              className="delivery-button"
              onClick={handleDeliveryCodeClick}
              style={{width:'100%',borderRadius: 8,
              fontWeight: 600,
              lineHeight: '26px',
              fontSize: 15,
              letterSpacing: '0.46px'}}
            >
              Deliver Certificate
            </button>
          </div>
        )}

      <DeliveryCodeModal
        show={showDeliveryCodeModal}
        onClose={() => setShowDeliveryCodeModal(false)}
        onSubmit={handleDeliveryCodeSubmit}
      />

        <ApproveModal
          show={showApproveModal}
          onClose={() => setShowApproveModal(false)}
          onSubmit={(data) => {
            handleDeliveryCodeSubmit(data.deliveryCode);
          }}
          userData={userData}
          idDistributor={userData.role.toLowerCase() === "distributor"}
          requestData={{
            request_id: freshRequestData.request_id,
            partner_id: freshRequestData.partner_id,
            certificate: freshRequestData.certificate,
          }}
        />

      {/* Image Preview Modal */}
      {previewImageUrl && (
        <div className="image-preview-overlay" onClick={closePreview}>
          <div className="image-preview-container" onClick={(e) => e.stopPropagation()}>
            <div className="image-preview-header">
              <div className="image-preview-zoom-controls">
                <button
                  className="image-preview-zoom-btn"
                  onClick={() => { setPreviewZoom((z) => Math.max(0.5, z - 0.25)); setPreviewPosition({ x: 0, y: 0 }); }}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/><line x1="8" y1="11" x2="14" y2="11"/></svg>
                </button>
                <span className="image-preview-zoom-level">{Math.round(previewZoom * 100)}%</span>
                <button
                  className="image-preview-zoom-btn"
                  onClick={() => setPreviewZoom((z) => Math.min(4, z + 0.25))}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/><line x1="11" y1="8" x2="11" y2="14"/><line x1="8" y1="11" x2="14" y2="11"/></svg>
                </button>
              </div>
              <button className="image-preview-close-btn" onClick={closePreview}>
                &times;
              </button>
            </div>
            <div
              className="image-preview-body"
              onPointerDown={handlePreviewPointerDown}
              onPointerMove={handlePreviewPointerMove}
              onPointerUp={handlePreviewPointerUp}
              style={{ cursor: previewZoom > 1 ? 'grab' : 'default' }}
            >
              <img
                src={previewImageUrl}
                alt="Preview"
                className="image-preview-img"
                style={{
                  transform: `scale(${previewZoom}) translate(${previewPosition.x / previewZoom}px, ${previewPosition.y / previewZoom}px)`,
                }}
                draggable={false}
              />
            </div>
          </div>
        </div>
      )}

    </div>
  );
};
